import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2bd7ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password__prefix" }

export function render(_ctx, _cache) {
  const _component_lock_outlined = _resolveComponent("lock-outlined")
  const _component_unlock_outlined = _resolveComponent("unlock-outlined")
  const _component_eye_invisible_outlined = _resolveComponent("eye-invisible-outlined")
  const _component_eye_outlined = _resolveComponent("eye-outlined")
  const _component_a_input = _resolveComponent("a-input")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_input, {
      value: _ctx.value,
      type: _ctx.passwordType,
      size: "large",
      placeholder: _ctx.placeholder,
      onChange: _ctx.onChange,
      maxlength: 20,
      autocomplete: "off"
    }, {
      prefix: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isLock)
            ? (_openBlock(), _createBlock(_component_lock_outlined, { key: 0 }))
            : (_openBlock(), _createBlock(_component_unlock_outlined, { key: 1 }))
        ])
      ]),
      suffix: _withCtx(() => [
        _createElementVNode("div", {
          class: "password__suffix",
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => (_ctx.togglePasswordType && _ctx.togglePasswordType(...args)), ["stop"]))
        }, [
          (_ctx.isLock)
            ? (_openBlock(), _createBlock(_component_eye_invisible_outlined, { key: 0 }))
            : (_openBlock(), _createBlock(_component_eye_outlined, { key: 1 }))
        ])
      ]),
      _: 1
    }, 8, ["value", "type", "placeholder", "onChange"])
  ]))
}